export const ORDERS_GRID = 'orders';
export const SHIPPINGS_GRID = 'shippings';
export const REGISTERS_GRID = 'registers';
export const RENTAL_GRID = 'rentalGrid';
export const RENTED_VEHICLES_GRID = 'rentedVehicles';
export const AUTOGROUPING_GRID = 'autogrouping';
export const AUTOGROUPING_ORDERS_GRID = 'autogroupingOrders';
export const INCIDENTS_GRID = 'incidents';
export const CLAIMS_GRID = 'claims';
